import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col} from 'react-bootstrap';
import buildUrl from "build-url-ts";
import HubspotCofigurationPage from './HubspotConfigurationPage';
import DeactivateIntegrationContainer from 'src/legacy/components/DeactivateIntegration/index';
import { shouldFetchIntegrations } from 'src/legacy/services/utils';
import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import DeactivatedSalesforce from 'src/legacy/images/deactivated_salesforce.svg';
import { HubspotOnboardingView } from './HubspotOnboardingView';
import { HubspotSideBar } from './HubspotSideBar';
import { localizedStrings } from 'src/localization/index.jsx';
import styles from './styles.module.scss';
import _ from 'lodash';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
class HubspotView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      deleteConfirmation: false,
      primaryId: _.get(this.props, "primaryIntegration.id"),
      primaryCreatedBy: _.get(this.props, "primaryIntegration.createdBy") || '',
      showIntergrationOnboarding: _.get(this.props, "integration") == 0,
      selectedTab: null,
      isScrollDisabled: false
    };

    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this.handleAuthenticateEvent = this.handleAuthenticateEvent.bind(this);
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);
    this.handleOverridePrimaryInstance = this.handleOverridePrimaryInstance.bind(this);
    this.handleOverrideSecondaryInstance = this.handleOverrideSecondaryInstance.bind(this);
    this.canEdit = this.canEdit.bind(this);
    this.showIntergrationOnboarding = this.showIntergrationOnboarding.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.disableScroll = this.disableScroll.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedHubspot = localizedStrings.components.integrations.hubspot;
    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedIntgerationActions = localizedStrings.components.integrations.actions;
  }

  componentDidMount() {
    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
    this.props.fetchHubspotIntegration();

    const integration = localizedStrings.constants.integrationsOnboarding.integrations.hubspot;
    const sections = integration.sections;
    this.setState({
      selectedTab: sections[0].id
    })
  }

  componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props.activeIntegrations, nextProps.activeIntegrations)){
      this.props.fetchHubspotIntegration();
    }
  }

  _handleDeactivateClicked(){
    this.props.fetchTotalHubspotIntegrations();
      this.setState({
        deleteConfirmation: true
      })
  }

  canEdit() {
    if (this.props.user.admin) {
      return true;
    } else if (this.state.primaryCreatedBy) {
      return this.state.primaryCreatedBy.id === this.props.user.id;
    }
    return false;
  }

  validateAuthError(){
    let integration = this.props.integration;
    if(integration.primaryIntegration && _.get(integration, "primaryIntegration.state.code") === 'ok'){
      return true;
    } else if (integration && _.get(integration, "primaryIntegration.id") == null && _.get(integration, "state.code") === 'ok'){
      return true;
    }
    return false;
  }

  showIntergrationOnboarding(){
    this.setState({
      showIntergrationOnboarding: !this.state.showIntergrationOnboarding
    })
  }

  disableScroll(value){
    this.setState({
      isScrollDisabled: value
    })
  }

  handleScroll(e){

    if(this.state.isScrollDisabled){
      return;
    }

    const integration = localizedStrings.constants.integrationsOnboarding.integrations.hubspot;
    const sections = integration.sections;
    
    for (let i = 0; i < sections.length; i++) {
      const element = document.getElementById(`${sections[i].id}`);

      if(element) {
        const offsets = element.getBoundingClientRect();
        const position = offsets.top;

        if(offsets) {
          if (e.target.scrollTop >= position) {
            this.setState({
              selectedTab: sections[i].id
            })
          }
        }
      }
    }
  }

  render(){

    var isAuthenticated = false;

    //secondary integration with account is present but primary integration authentication fails
    if(_.get(this.props, "integration.configuration.email") && _.get(this.props, "primaryIntegration.state.code") === "auth_error"){
        isAuthenticated = true;
    }
  
    if(this.props.integration && this.validateAuthError() && !this.props.error) {
        isAuthenticated = true;
    }

    var isPrimaryTokenExpired = _.get(this.props, "primaryIntegration.state.code") === "auth_error";
    var isSecondaryTokenExpired = _.get(this.props, "primaryIntegration.configuration.email")  && _.get(this.props, "integration.state.code") === 'auth_error';

    return (
      <div className={styles.content}>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <HubspotSideBar 
            integration={this.props.integration} 
            handleAuthenticate={this.handleAuthenticate} 
            showIntergrationOnboarding={this.showIntergrationOnboarding}
            _handleDeactivateClicked={this._handleDeactivateClicked}
            deactivating={this.props.deactivating}
            canEdit={this.canEdit}
            isAuthenticated = {isAuthenticated}
            authenticating = {this.props.authenticating}
            isPrimaryTokenExpired = {isPrimaryTokenExpired}
            handleOverridePrimaryInstance={this.handleOverridePrimaryInstance}
            navigate={this.props.navigate}
            isShowIntegrationOnboarding={this.state.showIntergrationOnboarding}
            />

          </Col>
          <Col md={9} id="right" className={styles.right} onScroll={(e) => this.handleScroll(e)}>
            {!isAuthenticated && _.size(this.props.integration) > 0 && !this.state.showIntergrationOnboarding && (
            <div className={styles.errorContainer}>
              <PlaceholderEmptyMessage
              title={this.localizedHubspot.error_messages.primary_expired.title}
              message={this.canEdit() ? this.localizedHubspot.error_messages.primary_expired.sub_text : this.localizedHubspot.error_messages.primary_expired.non_admin}
              image={DeactivatedSalesforce}
              className={styles.emptyMessage}
              visible={true}
            />
            </div>
            )}

            {(_.size(this.props.integration) == 0 || this.state.showIntergrationOnboarding) &&
            <HubspotOnboardingView 
            selectedTab={this.state.selectedTab}
            disableScroll={this.disableScroll}
            />
            }
            
            {isAuthenticated && this.props.integration && !this.state.showIntergrationOnboarding &&
            <HubspotCofigurationPage store={this.context.store} 
            handleOverrideSecondaryInstance={this.handleOverrideSecondaryInstance}
            handleOverridePrimaryInstance={this.handleOverridePrimaryInstance}
            isPrimaryTokenExpired = {isPrimaryTokenExpired}
            isSecondaryTokenExpired = {isSecondaryTokenExpired}
            handleAuthenticate = {this.handleAuthenticate}
            />}
          </Col>
        </Row>
        <DeactivateIntegrationContainer 
          name={this.localizedHubspot.title}
          type="hubspot"
          id = {_.get(this.props,"primaryIntegration") === null ? _.get(this.props, "integration.id") : _.get(this.props, "primaryIntegration.id")}
          message={this.localizedHubspot.sliders.deactivate.sub_text}
          accountsCount={this.props.totalHubspotIntegrations}
          show={this.state.deleteConfirmation}
          onCancel={()=> {
          this.setState({
             deleteConfirmation: false
          })
        }}
       />
      </div>
    );
  }

  handleAuthenticate(id, overrideInstance){
    //Calculate Position
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screen.top;
    
    var  width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    var   height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
    
    var w = 0.8 *width;
    var h = 0.8 * height;
    
    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
      
    const url = buildUrl(apiUrl, {
      path: `/api/2.0/integrations/hubspot/authorize`
    })

    var newWindow = window.open(url, `Authorize hubspot Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (newWindow.focus) {
      newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, (e) => this.handleAuthenticateEvent(e, id, overrideInstance), false);
    return false; 
  } 



  handleAuthenticateEvent(e, id, overrideInstance) {
    //Removing message event listner
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == 'HUBSPOT_AUTHORIZATION_SUCCESS') {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;
      this.props.trackAdoptionMetricsForPluginConnectedEvent("Hubspot");
      if (!error) {
        if(overrideInstance === 'primary' && !_.get(this.props, "saving")){
          this.props.overridePrimaryInstance(id, code).then(() => this.props.fetchHubspotIntegration());
        }
        else if(overrideInstance === 'secondary' && !_.get(this.props, "saving")){
          this.props.overrideAccount(id, code);
        } else if(!_.get(this.props, "authenticating")){
          this.props.authenticateAccount(code).then(() => this.props.fetchHubspotIntegration());
        }
      }

      deEventer(messageEvent, this.handleAuthenticateEvent, false);
    }
  }

  handleOverridePrimaryInstance(id){
    this.handleAuthenticate(id, 'primary');
  }

  handleOverrideSecondaryInstance(id){
    this.handleAuthenticate(id, 'secondary');
  }
}

export default HubspotView;